import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CompanyIntro from './components/CompanyIntro';
import PlatformStats from './components/PlatformStats';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const aboutFAQSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '今日看料是什么平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日看料是一个中文娱乐资讯聚合平台，创立于2023年。我们致力于为吃瓜群众提供最新、最快、最全面的网红爆料、娱乐八卦、热点事件追踪等实时内容，是中文互联网最具影响力的娱乐资讯平台之一。',
        },
      },
      {
        '@type': 'Question',
        name: '今日看料的内容来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日看料坚持真实、客观、公正的原则，严格审核每一条信息来源。我们拥有专业的编辑团队和广泛的信息网络，确保为用户提供经得起验证的资讯内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与今日看料进行商务合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过我们官网的商务合作表单提交需求，hello@rtxn.cn。我们的商务团队将在24小时内与您联系，洽谈广告投放、内容合作、品牌推广等合作事宜。',
        },
      },
      {
        '@type': 'Question',
        name: '今日看料有移动端App吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日看料提供App下载服务，您可以在官网找到最新下载地址。App支持iOS和Android双平台，为您提供更便捷的吃瓜体验。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 | 今日看料 - 品牌介绍与商务合作"
        description="今日看料品牌介绍——了解我们的品牌故事、平台数据、用户口碑与商务合作联系方式。今日看料致力于成为中国领先的娱乐资讯聚合平台，服务5000万+月活跃用户。"
        keywords="今日看料,关于我们,品牌介绍,商务合作,平台数据,用户口碑"
        canonicalUrl="http://rtxn.cn/about"
        schemaData={aboutFAQSchema}
        breadcrumbItems={[
          { name: '首页', url: 'http://rtxn.cn/' },
          { name: '关于我们', url: 'http://rtxn.cn/about' },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <section className="relative h-[280px] md:h-[360px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20background%20with%20soft%20amber%20and%20coral%20gradients%2C%20modern%20minimal%20aesthetic%2C%20clean%20sophisticated%20composition%2C%20gentle%20atmospheric%20lighting%2C%20professional%20editorial%20style%2C%20warm%20neutral%20tones%2C%20subtle%20texture%2C%20no%20text%2C%20elegant%20business%20mood&width=1400&height=360&seq=about-hero-01&orientation=landscape"
              alt="关于今日看料"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
              <nav className="flex items-center gap-1.5 text-xs md:text-sm text-background-50/80 mb-3" aria-label="面包屑导航">
                <a href="/" className="hover:text-background-50 transition-colors whitespace-nowrap">首页</a>
                <i className="ri-arrow-right-s-line text-[10px]"></i>
                <span className="text-background-50 font-medium">关于我们</span>
              </nav>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
                关于今日看料
              </h1>
              <p className="text-sm md:text-base text-background-50/85 max-w-xl leading-relaxed">
                吃瓜群众的一线热点追踪站——了解我们的故事、数据与合作机会
              </p>
            </div>
          </section>

          <CompanyIntro />
          <PlatformStats />
          <ContactSection />
        </main>

        <Footer />
      </div>
    </>
  );
}